module.exports = __webpack_public_path__ + "img/toolbelt.b0282d54.png";